const to_rgb = (colour, alpha) => {
	const a = (colour >> 24) & 0xFF;
	const r = (colour >> 16) & 0xFF;
	const g = (colour >> 8) & 0xFF;
	const b = colour & 0xFF;
	
	let stringValue = `rgb`;
	if( alpha ) {
		stringValue = `${stringValue}a`;
	}
	
        
	stringValue = `${stringValue}(${r},${g},${b}`;
	
	if( alpha ) {
		const alphaValue = a / 255.0;		
		stringValue = `${stringValue}, ${alphaValue}`;
	}
	
	stringValue = `${stringValue})`;

	return stringValue;

}

export {
  to_rgb
}
